
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { PanelPosition } from "@/types/ui";
import AppLayoutBodyPanelArea from "@/components/Reusable/AppLayout/AppLayoutBodyPanelArea.vue";
import GlobalSettingsPanel from "@/components/Settings/DocumentOrGlobalSettings/GlobalSettingsPanel.vue";
import SelectorsPanel from "@/components/Settings/Selectors/SelectorsPanel.vue";
import HistoryAndRevisionsPanel from "@/components/HistoryAndRevisions/HistoryAndRevisionsPanel.vue";
import { BrowseModeSupportedUIPanels } from "@/lib/browse-mode";

@Component({
  components: {
    HistoryAndRevisionsPanel,
    AppLayoutBodyPanelArea,
    GlobalSettingsPanel,
    SelectorsPanel
  }
})
export default class BrowseModeSidebarPanels extends Vue {
  @Prop()
  position!: PanelPosition;

  @Prop()
  panelState!: BrowseModeSupportedUIPanels | "closed";
}
